/**
 * we shortcut vm to use B tempates as there are no vm templates on egain side
 *
 * VM and B brand only support retail
 * @param config
 * @param brandId
 * @param isSme
 * @returns {*}
 */
export const getEntryPoint = (config, brandId, isSme) => {
  switch (brandId) {
    case 'CB':
      return isSme ? config.eGainCBSMEEntryPoint : config.eGainCBEntryPoint;
    case 'YB':
      return isSme ? config.eGainYBSMEEntryPoint : config.eGainYBEntryPoint;
    case 'VM':
      return isSme ? config.eGainVMSMEEntryPoint : config.eGainVMEntryPoint;
    default:
      return config.eGainBEntryPoint;
  }
};

// we parse out the referrer url like this to avoid pulling in any query params (that cold have an access_token in them)
export const getReferrerUrl = () => {
  const { proto, hostname } = window.location;
  return encodeURIComponent(`${proto}//${hostname}`);
};

export const setEgainUriMetaValues = (config, postChatAttributes, brandId, isSme) => {
  return {
    eGainCloudUrl: config.eGainCloudUrl,
    eGainTemplate: config.eGainTemplate,
    postChatAttributes,
    entryPoint: getEntryPoint(config, brandId, isSme),
    brandId: brandId.toLowerCase() === 'vm' ? 'b' : brandId,
    // todo the old code set this to an empty string why
    refererName: encodeURIComponent('')
  };
};

export const setEgainUriParams = (
  refererUrl,
  { eGainCloudUrl, eGainTemplate, postChatAttributes, entryPoint, brandId, refererName }
) => {
  let queryString = eGainTemplate
    .replace('{postattribute}', postChatAttributes)
    .replace('{entrypoint}', entryPoint)
    .replace(/{brand}/g, brandId)
    .replace('{referrername}', refererName)
    .replace('{eglvcaseid}', '') // this is not required to have a value
    .replace('{vhtIds}', ''); // this is not required to have a value
  let eGainChatUrl = `${eGainCloudUrl}${queryString}`;
  // todo dept only set the referrer if the URL can accommodate the characters. Not sure why this is here suspect limitation on egain side
  if ((eGainChatUrl + refererUrl).length <= 2000) eGainChatUrl += '&referer=' + refererUrl;
  return eGainChatUrl;
};

/**
 * Once we have all the required parameter info we post that back to a native method of 'setEgainParameters'. The mobile app then navigates to the main egain URL
 * @param eGainUrl
 * @param samlToken
 * @param postChatAttributes
 */
export const postToNativeApp = (eGainUrl, samlToken, postChatAttributes) => {
  const payload = {
    eGainUrl,
    SAMLResponse: samlToken,
    eGainChatIdentifier: postChatAttributes ? 'true' : 'false'
  };
  if (window.AndroidInterface) {
    window.AndroidInterface.setEgainParameters(JSON.stringify(payload));
  } else if (window.webkit) {
    window.webkit.messageHandlers.setEgainParameters.postMessage(JSON.stringify(payload));
  } else {
    throw new Error('No mobile interface detected');
  }
};
